import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import PasswordForm from "../forms/passwordForm";
import DeviceContext from "../../../services/indentifyDevice";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import { IPasswordFormProps } from "../forms/passwordForm";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

export interface IPasswordScreenProps extends IPasswordFormProps {
  onClose?: () => void;
}

const PasswordScreen: React.FC<IPasswordScreenProps> = (props) => {
  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      onClose={props.onClose}
      className="login_scrn"
    >
      <PasswordForm {...props} />
    </LoginPopup>
  );
};

export default PasswordScreen;
